module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_epopcon_m2.5b695feb68e508e4f4ae21b6671cb0b0.png";